<script>
export default {
  components: {
  },
  created () {
  },
  data () {
    return {
      versionData: process.env
    }
  }
}
</script>

<template>
	<div class="p3">
		<p class="h4 bold darkblue line-height-2 my3">Version</p>
		<p v-for="(version, index) in versionData" :key="index"><span class="bold caps">{{index}}</span>: {{version}}</p>
	</div>
</template>


// WEBPACK FOOTER //
// version.vue?527eadee